import { Dispatch, SetStateAction, useEffect } from 'react';
import { useIntl } from 'react-intl';

import { Button } from 'components/button';
import { Icon } from 'components/icon/icon';

import IconFilter from 'public/assets/icons/filter.svg';
import IconSelect from 'public/assets/icons/union.svg';

import styles from '../subsidy-overview.module.scss';

export interface IMobileActionsProps {
	filtersIsOpen: boolean;
	setFiltersIsOpen: Dispatch<SetStateAction<boolean>>;
	sortIsOpen: boolean;
	setSortIsOpen: Dispatch<SetStateAction<boolean>>;
}

export const MobileActions = ({
	filtersIsOpen,
	setFiltersIsOpen,
	sortIsOpen,
	setSortIsOpen
}: IMobileActionsProps): React.JSX.Element => {
	const intl = useIntl();

	useEffect(() => {
		if (filtersIsOpen || sortIsOpen) {
			document.body.style.overflow = 'hidden';
		} else {
			document.body.style.overflow = 'visible';
		}
	}, [filtersIsOpen, sortIsOpen]);

	return (
		<div className={styles.mobileButtons}>
			<Button
				variant="secondary-light"
				title={intl.formatMessage({ id: 'global.filter' })}
				icon={<Icon customIcon={<IconFilter />} size="14px" />}
				onClick={() => setFiltersIsOpen(!filtersIsOpen)}
			/>
			<Button
				variant="secondary-light"
				title={intl.formatMessage({ id: 'global.sort' })}
				icon={<Icon customIcon={<IconSelect />} size="14px" />}
				onClick={() => setSortIsOpen(!sortIsOpen)}
			/>
		</div>
	);
};

export default MobileActions;
